import axios from "axios";
import { useState } from "react";
import { Input } from "manifest-components/src/Inputs/Input";
import { Spacing } from "manifest-components/src/Containers";
import Autocomplete from "manifest-components/src/Inputs/Autocomplete";
import { ReactSelectOptions } from "manifest-components/src/types";
import { Dropdown } from "manifest-components/src/Inputs/Dropdowns";

const radarAxios = axios.create({
  headers: {
    Authorization: "prj_test_pk_02917859217bdc3ee31d9b0d20d3e05d5ed14055",
  },
  baseURL: "https://api.radar.io/v1/search/autocomplete",
});
type Address = {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  zipCode: string;
};

const AddressAutoFill = () => {
  const [address, setAddress] = useState<Address>({
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipCode: "",
  });

  const onLoadAddress = async (query: string): Promise<ReactSelectOptions> => {
    const res = await radarAxios.get(`?query=${query}&countryCode=US`);
    return res.data.addresses.map((entry) => {
      return {
        label: entry.formattedAddress,
        value: JSON.stringify(entry),
      };
    });
    // return [];
  };
  return (
    <div style={{ width: "100%", maxWidth: "600px" }}>
      {/* <Input
        name="addressLine1"
        autoComplete="street-address"
        onChange={onInputHandler}
        title="Current address line 1"
        required
        value={address.addressLine || ""}
      /> */}
      <Autocomplete
        name="addressLine1"
        data-name="addressLine1"
        creatable
        title="Current address line 1"
        value={address.addressLine1 || ""}
        options={[]}
        onChange={(e) => {
          if (!e) {
            setAddress({ ...address, addressLine1: "" });
            return;
          }
          try {
            const addObj = JSON.parse(e);

            setAddress({
              addressLine1: addObj.addressLabel,
              city: addObj.city,
              state: addObj.state,
              zipCode: addObj.postalCode,
            });
          } catch {
            setAddress({ ...address, addressLine1: e });
          }
        }}
        onLoadOptions={onLoadAddress}
        //   titleColor={titleColor}
        //   onBlur={onBlur}
      />
      <Spacing $space={20} />
      <Input
        name="addressLine2"
        autoComplete="address-line2"
        title="Current address line 2"
        onChange={(e) => setAddress({ ...address, addressLine2: e })}
        value={address.addressLine2}
      />
      <Spacing $space={20} />
      <Input
        name="city"
        autoComplete="address-level2"
        onChange={(e) => setAddress({ ...address, city: e })}
        required
        title="City"
        value={address.city || ""}
      />
      <Spacing $space={20} />
      <Dropdown
        name="state"
        onChange={(e) => setAddress({ ...address, state: (e?.value as string) || "" })}
        options={[
          "Alabama",
          "Alaska",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Florida",
          "Georgia",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming",
          "District of Columbia",
        ].map((e) => {
          return {
            label: e,
            value: e,
          };
        })}
        required
        title="State"
        value={address.state || ""}
      />
      <Spacing $space={20} />
      <Input
        name="postalCode"
        autoComplete="postal-code"
        // handleBlur={() => validateField("zipCode")}
        onChange={(e) => setAddress({ ...address, zipCode: e })}
        required
        title="Zip code"
        value={address.zipCode || ""}
      />
    </div>
  );
};

export default AddressAutoFill;
